
import { cn } from "@/marketing/lib/utils";
import { Search, LayoutGrid, FileText, Zap, Users, Ticket } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { MARKETING_ROUTES } from "@/marketing/routes";

const NAV_ITEMS = [
  { label: "Influencer Explorer", icon: Search, to: MARKETING_ROUTES.influencers },
  { label: "Brand Manager", icon: LayoutGrid, to: MARKETING_ROUTES.brandManager },
  { label: "Template Manager", icon: FileText, to: MARKETING_ROUTES.templateManager },
  { label: "Campaign Manager", icon: Zap, to: MARKETING_ROUTES.campaignMatcher },
  { label: "Community", icon: Users, to: MARKETING_ROUTES.community },
  { label: "Affiliate", icon: Ticket, to: MARKETING_ROUTES.affiliate },
] as const;

export function Sidebar() {
  const { pathname } = useLocation();

  return (
    <aside className="tw-flex tw-h-screen tw-w-[240px] tw-shrink-0 tw-flex-col tw-border-r tw-border-sidebar-border tw-bg-sidebar">
      {/* No brand header here: the admin navbar already owns the product identity. */}
      <nav className="tw-flex-1 tw-px-3 tw-py-4">
        <p className="tw-mb-2 tw-px-2 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wider tw-text-muted-foreground">
          Workspace
        </p>
        <ul className="tw-space-y-1">
          {NAV_ITEMS.map((item) => {
            const isActive =
              item.to === MARKETING_ROUTES.influencers
                ? pathname === item.to || pathname === `${item.to}/`
                : pathname.startsWith(item.to);
            return (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className={cn(
                    "tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-px-2 tw-py-2 tw-text-sm",
                    isActive
                      ? "tw-bg-accent tw-text-accent-foreground tw-font-medium"
                      : "tw-text-sidebar-foreground hover:tw-bg-accent/50",
                  )}
                >
                  <item.icon className="tw-h-4 tw-w-4" />
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
      {/* No user/logout block here: the admin navbar already owns the session UI. */}
    </aside>
  );
}
